import React from "react";
import { useListContext, useRefresh, useTranslate } from "react-admin";
import { Button, CircularProgress } from "@material-ui/core";
import { httpClient } from "api/httpClient";
import { useNotifySuccess } from "utils/notifiers/useNotifySuccess";
import { useNotifyError } from "utils/notifiers/useNotifyError";
import { ExternalTerminalConnectionStatus } from "entities/ExternalTerminalConnectionStatus";


export function ConnectionActionButton({ record }) {
    const refresh = useRefresh();
    const t = useTranslate();
    const notifySuccess = useNotifySuccess();
    const notifyError = useNotifyError();
    const [loading, setLoading] = React.useState(false);

    if (!record) return null;

    const patchStatus = async (newStatus) => {
        setLoading(true);
        try {
            await httpClient(`/external-terminal-links/${record.id}`, {
                method: "PATCH",
                body: JSON.stringify({ status: newStatus }),
            });
            notifySuccess(t("resources.external-terminal-links.notifications.success_status_change"));
            refresh();
        } catch (e) {
            notifyError(e);
        } finally {
            setLoading(false);
        }
    };

    const RefuseButton = () => (
        <Button
            variant="contained"
            color="red"
            onClick={() => patchStatus(ExternalTerminalConnectionStatus.refused)}
        >
            {loading ? (
                <CircularProgress size={16} thickness={5} />
            ) : (
                t("resources.external-terminal-links.buttons.refuse_request")
            )}
        </Button>
    );

    if (
        record.status === ExternalTerminalConnectionStatus.not_connected ||
        record.status === ExternalTerminalConnectionStatus.refused
    ) {
        return (
            <Button
                variant="contained"
                onClick={() => patchStatus(ExternalTerminalConnectionStatus.requested)}
            >
                {loading ? (
                    <CircularProgress size={16} thickness={5} />
                ) : (
                    t("resources.external-terminal-links.buttons.request_connection")
                )}
            </Button>
        );
    }

    if (record.status === ExternalTerminalConnectionStatus.requested) {
        if (record.i_am_initiator === true) {
            return <RefuseButton />;
        }
        if (record.i_am_initiator === false) {
            return (
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => patchStatus(ExternalTerminalConnectionStatus.connected)}
                    >
                        {loading ? (
                            <CircularProgress size={16} thickness={5} />
                        ) : (
                            t("resources.external-terminal-links.buttons.accept")
                        )}
                    </Button>
                    <span style={{ display: "inline-block", width: 32 }} />
                    <RefuseButton />
                </>
            );
        }
    }

    return null;
};
